import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TStatusApi } from './types/statusApi.types'

export const statusApi = {
  getStatus: ({ signal }: TSignalConfig) =>
    fetcher.query<TStatusApi>('/status', {
      signal,
    }),
}
